<template>
  <PictureElement
    :breakpoints="imageBreakpoints"
    :img="image"
    img-class="transition-transform duration-300 hover:-translate-y-4 object-cover"
  ></PictureElement>
</template>

<script setup>
import PictureElement from "~/templates/elements/PictureElement.vue";

import { DIMENSIONS } from "~/utils/helper/imaging";
const imageBreakpoints = {
  start: DIMENSIONS["start"].ratio.original,
  sm: DIMENSIONS["sm"].ratio.original,
  md: DIMENSIONS["md"].width["1/3"].ratio.original,
  xl: DIMENSIONS["xl"].width["1/4"].ratio.original,
};
defineProps(["image"]);
</script>
